import styled from 'styled-components';

export const RequiredMark = styled.span`
	color: red;
`;
